/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  TPanelEventCallback,
  TPanelEventIdentifier,
  TPanelEventRegister,
  TPanelIdentifier,
} from './types';

function identifierAfitsOnB(
  a: Partial<TPanelEventIdentifier>,
  b: TPanelEventIdentifier,
) {
  // eslint-disable-next-line no-restricted-syntax, @typescript-eslint/no-for-in-array
  for (const key of Object.keys(a)) {
    if (
      a[key as keyof Partial<TPanelIdentifier>] !==
      b[key as keyof TPanelIdentifier]
    )
      return false;
  }

  return true;
}

export const eventsController = new (class EventsController {
  callbacks: TPanelEventRegister<any>[] = [];

  broadcast(eventType: string, payload: any) {
    const origin: TPanelIdentifier = {
      panelId: 'broadcast',
      panelName: 'broadcast',
      panelType: 'broadcast',
      panelTitle: 'broadcast',
    };

    this.callbacks.forEach(({ callback, ...current }) => {
      if (eventType === current.eventType) {
        callback({ ...origin, eventType, payload });
      }
    });
  }

  fireEvent(origin: TPanelIdentifier, eventType: string, payload: any) {
    if ([origin.panelId, origin.panelName, origin.panelType].includes('*'))
      throw new Error(
        'Broadcast is not allowed through fireEvent, use broadcast instead',
      );

    this.callbacks.forEach(({ callback, ...current }) => {
      if (identifierAfitsOnB(current, { ...origin, eventType })) {
        callback({ ...origin, eventType, payload });
      }
    });
  }

  onEvent<PayloadEvent>(
    distinction: Partial<TPanelEventIdentifier>,
    callback: TPanelEventCallback<PayloadEvent>,
  ) {
    const register: TPanelEventRegister<PayloadEvent> = {
      ...distinction,
      callback,
    };

    this.callbacks.push(register);

    return () => {
      this.callbacks = this.callbacks.filter((current) => {
        return current !== register;
      });
    };
  }
})();
